var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "doctor-appointment-stub text-body-1",
      attrs: { "data-qa": "lpu_doctors_list_appointment_unavailable" },
    },
    [_vm._v("\n  " + _vm._s(_setup.tStatic("Запись недоступна")) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }